import { getClasses } from '../../utils/styler';

import { useCallback } from 'react';

const maskCpf = value => {
	if (!value || value.length > 14) {
		return value;
	}

	return value
		.replace(/\D/g, '')
		.replace(/(\d{3})(\d)/, '$1.$2')
		.replace(/(\d{3})(\d)/, '$1.$2')
		.replace(/(\d{3})(\d)/, '$1-$2');
};

const maskMethodByName = {
	cpf: maskCpf
};

const DocaInputField = ({ onChange, disabled, mask, ...props }) => {
	const isNumber = useCallback(
		(value) => !isNaN(~~value),
		[]
	);

	const clearMask = useCallback(
		(value) => {
			if (!value || isNumber(value)) {
			return value;
			}

			return value.replace(/\D/g, '');
		},
		[isNumber]
	);

	const handleInputChange = useCallback(
		(event) => {
			event.preventDefault();

			if (mask && maskMethodByName[mask]) {
				const { value } = event.target;

				const maskedValue = maskMethodByName[mask](value);

				event.target.value = maskedValue;
			}

			if (onChange) {
				onChange(event);
			}
		},
		[mask, onChange]
	);

	const handleOnPaste = useCallback(
		(event) => {
			const clipboardData = (event.originalEvent || event).clipboardData || window.clipboardData;

			const clipboardDataValues = clipboardData.getData('text');

			event.target.value = clearMask(clipboardDataValues);

			handleInputChange(event);
		},
		[handleInputChange, clearMask]
	);

	return <input className={getClasses({ ...props }, {
		'doca-form-control': true,
		'doca-px-3': true,
	})} disabled={disabled} onChange={handleInputChange} onPaste={handleOnPaste} {...props} />
};

export default DocaInputField;
